// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__31U88","bounce1":"loader_bounce1__3tnG1","bounce2":"loader_bounce2__31li3","sk-bounce":"loader_sk-bounce__LRB5V"};